export const CurrencyMapping = {
    'JPY': 'JPY・Day',
    'USD': 'USD・Day'
}